import type { GenerateAppSchemaParameters } from '@sap/ux-specification-types';

/**
 * Generates an app specific schema for the FE V4 Freestyle page from the generic schema.
 * Generic types are replaced by information from the app specific annotations.
 *
 * @param _generateParameters - list of API input parameters
 * @param genericSchema  - generic JSON schema of an object page
 * @returns {object} application-specific schema of the freestyle page
 */
export function generateFreestyleSchemaV4(
    _generateParameters: GenerateAppSchemaParameters,
    genericSchema: object
): object {
    return JSON.parse(JSON.stringify(genericSchema));
}
